import { configureStore } from '@reduxjs/toolkit';
import generalReducer from './reducers/general.reducer';
import userReducer from './reducers/user.reducer';

export default configureStore({
  reducer: {
    general: generalReducer,
    user: userReducer,
  },
});
